export const PRODUCT_CATEGORIES = [    
    "Big Vehicle",
    "Medium Vehicle",
    "Small Vehicle",
]; 

export const GOODS_TYPE =[
    "Coils",
    "Bundles",
    "Steel Sheets",
    "Box Pack",
    "Garments",
    "Furniture",
    "Home Shifting",
    "Other",
]